import { render, staticRenderFns } from "./ImportContactsModal.vue?vue&type=template&id=2d954380&scoped=true"
import script from "./ImportContactsModal.vue?vue&type=script&lang=js"
export * from "./ImportContactsModal.vue?vue&type=script&lang=js"
import style0 from "./ImportContactsModal.vue?vue&type=style&index=0&id=2d954380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d954380",
  null
  
)

export default component.exports